import RedirectLink from '@Components/RedirectLink';
import TableTemplate from '@Dashboard/Charts/TableTemplate';
import { MAIL_SERVICES } from '@Dashboard/RiskUser/utils';
import { generateRedirectUrlToLog } from '@Log/shared';
import { useDashboardServicesStore } from '@Models/useDashboardServicesModel';
import { useUtcOffsetStore } from '@Models/useUtcOffsetModel';
import { ServiceNameEnum } from '@Types/index';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';
import { ThreatType } from '@Utils/enums';
import { getServiceNamesByValues } from '@Utils/service';
import { getUtcTime } from '@Utils/time';
import { useColorMode, useColorStyle, Box, Text } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import ContextMenu from '@Components/ContextMenu';

const HighRiskRecipientsTable = (props: { insightsData: any; day: string }) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  const timeModel = useUtcOffsetStore();
  const servicesModel = useDashboardServicesStore();
  const services = servicesModel.enabledServices;

  const config = [
    { width: '20%', grow: 2, align: 'left', tooltip: true },
    { width: '10%', grow: 1, align: 'rigth' },
    { width: '10%', grow: 1, align: 'rigth' },
    { width: '10%', grow: 1, align: 'rigth' },
    { width: '10%', grow: 1, align: 'rigth' },
    { width: '10%', grow: 1, align: 'rigth' },
    { width: '20%', grow: 2, align: 'left' },
  ];
  const header = [
    t('riskUser.topUser.user'),
    t('riskUser.topUser.totalAmount'),
    t('riskUser.topUser.phishing'),
    t('riskUser.topUser.ransomware'),
    t('riskUser.topUser.maliciousFile'),
    t('riskUser.topUser.maliciousUrl'),
    t('riskUser.topUser.received'),
  ];
  const data = (props.insightsData?.RiskyTopRecipients?.[props.day] || []).map(
    (x: any) => {
      return [
        x.key || '',
        renderLink(
          (x.phishing || 0) +
            (x.ransomware || 0) +
            (x.malicious_file || 0) +
            (x.malicious_url || 0),
          x.key || '',
          props.day,
          [
            ThreatType.Phishing,
            ThreatType.Ransomware,
            ThreatType.MaliciousFile,
            ThreatType.MaliciousURL,
          ],
          services
        ),
        renderLink(
          x.phishing || 0,
          x.key || '',
          props.day,
          [ThreatType.Phishing],
          services
        ),
        renderLink(
          x.ransomware || 0,
          x.key || '',
          props.day,
          [ThreatType.Ransomware],
          services
        ),
        renderLink(
          x.malicious_file || 0,
          x.key || '',
          props.day,
          [ThreatType.MaliciousFile],
          services
        ),
        renderLink(
          x.malicious_url || 0,
          x.key || '',
          props.day,
          [ThreatType.MaliciousURL],
          services
        ),
        x.last_detected
          ? getUtcTime(
              x.last_detected,
              timeModel.offset,
              t('common.momentDateFormat')
            )
          : '',
      ];
    }
  );

  return (
    <Box>
      <Box
        mb="24px"
        fontSize="18px"
        fontWeight="600"
        lineHeight="24px"
        color={colorStyle.color.primary}
      >
        {t('riskUser.topUser.recipient')}
      </Box>
      <TableTemplate
        height="220px"
        config={config}
        header={header}
        data={data}
        appendContextMenu={{
          columnIndex: 0,
          enabled: true,
          component: (user: string) => {
            return (
              <ContextMenu user={user} responseActionShow={false}></ContextMenu>
            );
          },
        }}
      />
    </Box>
  );
};

export default HighRiskRecipientsTable;

function renderLink(
  count: number,
  recipient: string,
  day: string,
  threatType: ThreatType[],
  services: ServiceNameEnum[]
) {
  if (count === 0) {
    return 0;
  }
  return (
    <RedirectLink
      href={`logs?${generateRedirectUrlToLog(
        [
          {
            field: 'threatType',
            values: threatType,
            type: 'terms',
          },
          {
            field: 'violator',
            values: [recipient],
            type: 'terms',
          },
          // {
          //   field: 'mailDirection',
          //   type: 'mustNot',
          //   values: ['out'],
          //   subType: 'terms',
          // },
          {
            field: 'scanSource',
            values: getServiceNamesByValues(
              services.filter((x) => MAIL_SERVICES.has(x))
            ),
            type: 'terms',
          },
          {
            field: 'securityFilterName',
            values: [
              SecurityFilterName.AdvancedSpamProtection,
              SecurityFilterName.MalwareScanning,
              SecurityFilterName.VirtualAnalyzer,
              SecurityFilterName.WebReputation,
              SecurityFilterName.ContentFiltering,
            ],
            type: 'terms',
          },
        ],
        day,
        LogTypeEnum.DETECTION
      )}`}
    >
      <Text>{count}</Text>
    </RedirectLink>
  );
}
